/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { readLocalStorage, writeLocalStorage, writeSessionStorage } from 'common/utils/StorageUtil'

const initialState = {
    user: undefined,
    titles: [],
    actions: [],
    isMute: readLocalStorage('SOUND_MUTE'),
    isNewTicketAlertMute: readLocalStorage('NEW_TICKET_ALERT_MUTE'),
    isWaiting: false,
}

const appSlice = createAppSlice({
    name: 'app',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        titles: create.reducer((state, action) => {
            state.titles = action.payload
        }),
        actions: create.reducer((state, action) => {
            state.actions = action.payload
        }),
        toggleMute: create.reducer((state) => {
            writeLocalStorage('SOUND_MUTE', !state.isMute)
            state.isMute = !state.isMute
        }),
        toggleNewTicketAlertMute: create.reducer((state) => {
            writeLocalStorage('NEW_TICKET_ALERT_MUTE', !state.isNewTicketAlertMute)
            state.isNewTicketAlertMute = !state.isNewTicketAlertMute
        }),
        startWaiting: create.reducer((state) => {
            state.isWaiting = true
        }),
        stopWaiting: create.reducer((state) => {
            state.isWaiting = false
        }),

        discordLogin: create.asyncThunk(
            async (code, { rejectWithValue }) => {
                try {
                    const { login, token } = await aquaFetch(ApplicationConf.auth.loginWithDiscord(code))
                    writeSessionStorage('aquaparc-token', token)
                    writeSessionStorage('aquaparc-login', login)
                    return await aquaFetch(ApplicationConf.auth.user(login))
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la connection avec discord')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: (state, action) => {
                    state.user = action.payload
                },
            }
        ),
        logout: create.asyncThunk(
            async (_, { fulfillWithValue, rejectWithValue }) => {
                try {
                    // return await aquaFetch(ApplicationConf.auth.logout())
                    toast.info('Psykokwak est triste de ne plus te voir')
                    return fulfillWithValue()
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la déconnection')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: (state) => {
                    writeSessionStorage('aquaparc-token', undefined)
                    writeSessionStorage('aquaparc-login', undefined)
                    state.user = undefined
                },
            }
        ),
        fetchUser: create.asyncThunk(
            async (login, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.auth.user(login))
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement de l\'utilisateur')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: (state, action) => {
                    state.user = action.payload
                },
            }
        ),
    }),
})

export const { fetchUser, discordLogin, logout, startWaiting, stopWaiting, ...AppActions } = appSlice.actions
export default appSlice